'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002429 from "./presto.-Agent-View$$anon$29.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Request$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$28() {
  this.ayj = null;
  this.ayb = null;
  this.ayc = false;
  this.ayk = null;
  this.ayl = false;
  this.ayo = null;
  this.ayh = null;
  this.ayi = false;
  this.ayd = null;
  this.aye = false;
  this.ayf = null;
  this.ayg = false;
  this.aym = false;
  this.ayn = false;
  this.ayj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ayo = "LocalPjeOfficeSignHashRequest";
}
export { $c_Lpresto_AgentView$$anon$28 as $c_Lpresto_AgentView$$anon$28 };
$p = $c_Lpresto_AgentView$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$28;
/** @constructor */
function $h_Lpresto_AgentView$$anon$28() {
}
export { $h_Lpresto_AgentView$$anon$28 as $h_Lpresto_AgentView$$anon$28 };
$h_Lpresto_AgentView$$anon$28.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ayj;
});
$p.L = (function() {
  if ((!this.ayc)) {
    this.ayb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ayc = true;
  }
  return this.ayb;
});
$p.O = (function() {
  if ((!this.ayl)) {
    this.ayk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ayl = true;
  }
  return this.ayk;
});
$p.E = (function() {
  return this.ayo;
});
$p.t = (function() {
  if ((!this.ayi)) {
    this.ayh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hashes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.ayi = true;
  }
  return this.ayh;
});
$p.M = (function() {
  if ((!this.aye)) {
    this.ayd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2A())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aye = true;
  }
  return this.ayd;
});
$p.Q = (function() {
  if ((!this.ayg)) {
    this.ayf = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002429.$c_Lpresto_AgentView$$anon$29();
    this.ayg = true;
  }
  return this.ayf;
});
$p.w = (function() {
  if ((!this.ayn)) {
    this.aym = false;
    this.ayn = true;
  }
  return this.aym;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee196) => ((p) => \u03b4scrutinee196.cFP(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$())));
});
var $d_Lpresto_AgentView$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$28, "presto.AgentView$$anon$28", ({
  DR: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$28 as $d_Lpresto_AgentView$$anon$28 };
//# sourceMappingURL=presto.-Agent-View$$anon$28.js.map
